import { configureFirestore } from 'features/firebase/configureFirestore';
import { getProtocolEditorService } from 'features/questionnaires/services/proseServiceFactory';
import { preloadPluginWebCode } from './preloadPluginWebCode';

/**
 * Starts loading the code every page needs once signed in: the Firestore
 * setup first (sign-in reads the user record with it; it sends no request
 * until the first read), then the plugin web code, then the PROSE engine,
 * the largest. Failures are dropped; later callers share a pending load.
 */
export const preloadSignedInCode = (): void => {
  configureFirestore().catch(() => undefined);
  preloadPluginWebCode();
  getProtocolEditorService().catch(() => undefined);
};
